import { createFileRoute } from "@tanstack/react-router";

import { BalanceSheetPage } from "@/features/qbo/ui/BalanceSheetPage";

export const Route = createFileRoute("/_authenticated/balance_sheet")({
  component: BalanceSheetPage,
});
